export default __webpack_public_path__ + "static/media/microscope.98fe5f2d.svg";